import React, {useEffect, useState} from 'react';
import HomepageTabBar from "../components/molecules/HomepageTabBar";
import {Redirect, Route, Switch} from "react-router-dom";
import Header from "../components/organisms/Header";
import PageTitle from "../components/PageTitle";
import HomepageHotNowList from "../components/organisms/HomepageHotNowList";
import HomeStore from "../flux/HomeStore";
import Modal from "../components/Modal";
import TermList from "../components/TermList";
import {createPortal} from "react-dom";
import styled from "styled-components";
import Close from "../icons/Close";
import HomeStoreActions from "../flux/HomeStoreActions";
import __ from "../utils/translator";
import themeResponsiveProperty from "../components/responsive/themeResponsiveProperty";
import HomepageToCompleteList from "../components/organisms/HomepageToCompleteList";
import HomepageNeverSeenList from "../components/organisms/HomepageNeverSeenList";

export default function Homepage() {
  const [termsList, setTermsList] = useState(null);

  const onHomeStoreChange = () => {
    const {selectedTerms} = HomeStore.getState();
    setTermsList(selectedTerms);
  }

  useEffect(() => {
    const subscription = HomeStore.addListener(onHomeStoreChange)
    return () => {
      subscription.remove();
    };
  }, []);


  return (
    <>
      <PageTitle withTracking title="Home" />

      <Header>
        <HomepageTabBar />
      </Header>

      <div>

        <Switch>
          <Route path="/hot-now" exact component={HomepageHotNowList} />
          <Route path="/to-complete" exact component={HomepageToCompleteList} />
          <Route path="/never-seen" exatc component={HomepageNeverSeenList} />
        </Switch>
      </div>

      {termsList !== null && (
        createPortal(
           <GlossaryModal>
             <ModalHeader>
               <ModalTitle>{__('Glossary')}</ModalTitle>
               <CloseIcon onClick={() => HomeStoreActions.openTermModal(null)}/>
             </ModalHeader>
             <ModalBody>
               <TermList terms={termsList}/>
             </ModalBody>
           </GlossaryModal>,
          window.document.body
        )
      )}
    </>
  )
}

const GlossaryModal = styled(Modal)`
  width: ${themeResponsiveProperty('90%', '90vw')};
  max-height: 90%;
  margin: 1rem;
  padding: 0;
  background-color: #FFF;
  border-radius: 0.625rem;
`;

const ModalTitle = styled.span`
  text-transform: uppercase;
`;

const ModalHeader = styled.div`
  width: calc(100% - 2rem);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 1rem 0;
  margin: 0 1rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.25);
`;

const ModalBody = styled.div`
  width: 100%;
  max-height: 70vh;
  overflow-y: auto;

  svg {
    width: 1.4rem;
  }
`;

const CloseIcon = styled(Close)`
  width: 0.875rem;
  cursor: pointer;
`;
